// Module
var code = `<h2 class="font-lusitana mb-4 text-xl md:text-2xl">{{heading}}</h2>
<div class="rounded-xl bg-gray-50 p-4">
  <div
    class="sm:grid-cols-13 mt-0 grid grid-cols-12 items-end gap-2 rounded-md bg-white p-4 md:gap-4"
  >
    <div
      class="mb-6 hidden flex-col justify-between text-sm text-gray-400 sm:flex"
      style="height: {{chartHeight}}px"
    >
      {{#yAxisLabels}}
      <p>{{.}}</p>
      {{/yAxisLabels}}
    </div>
    {{#bars}}
    <div class="flex flex-col items-center gap-2">
      <div
        class="w-full rounded-md bg-blue-300"
        style="height: {{attrBarHeight}}px"
      ></div>
      <p class="-rotate-90 text-sm text-gray-400 sm:rotate-0">{{month}}</p>
    </div>
    {{/bars}}
  </div>
  <div class="flex items-center pb-2 pt-6">
    {{svgCalendar}}
    <h3 class="ml-2 text-sm text-gray-500">{{footerText}}</h3>
  </div>
</div>
`;
// Exports
module.exports = code;